import { useEffect } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import * as authAction from "../redux/auth/action";
import { ROUTE_LOGIN } from "../resources/routes-name";
import { windowNavigateReplaceTo } from "../utils/navigation/navigation-services";
import { getAuthToken } from "../utils/storage/storage";

export const useAuthEffect = () => {
  const dispatch = useDispatch();
  const userState = useSelector((state: IAuthState) => state.auth.user);

  useEffect(() => {
    if (!userState) {
      const accessToken = getAuthToken();
      if (!accessToken) {
        if (window.location.pathname.search("/account/handle") === -1) {
          windowNavigateReplaceTo({ pathname: ROUTE_LOGIN });
        }
        return;
      }
      if (window.location.pathname.search("/account/handle") !== -1) {
        return;
      }
      const reqBody = {
        accessToken,
      };
      setTimeout(() => dispatch(authAction.userAuthCurrent(reqBody)), 200);
    }
  }, [dispatch, userState]);
};

export const useAuthLogin = () => {
  function toLogin() {
    windowNavigateReplaceTo({ pathname: ROUTE_LOGIN });
  }

  return {
    toLogin,
  };
};
